<template>
  <div class="AnnouncementWrapper">
    <div class="NotificationIconWrapper">
      <Notification />
    </div>
    <div class="AnnouncementText">
      お知らせ：ポケカオリパ販売中！！【詳細は<TextLink 
        text="こちら" 
        inline 
        to="https://www.ka-nabell.com/?act=sell_search&type=4&category=77946&supply=1&lang=&genre=1" 
        size="xs" 
        target="_blank"
      />】
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from "#app";
import { Notification } from '@ka-nabellinc/ka-nabell-icons';
import { TextLink } from '@ka-nabellinc/ka-nabell-ui'

export default defineNuxtComponent({
  components: {
    Notification,
    TextLink,
  },
});
</script>

<style scoped>
.AnnouncementWrapper {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 4px;
  padding: 8px 16px;
}

.NotificationIconWrapper {
  width: 24px;
  height: 24px;
}

.AnnouncementText {
  font-size: 11px;
  line-height: 160%;
  letter-spacing: 0.11px;
}
</style>